// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowLeft: React.FC<{ width?: number; height?: number }> = ({ width = 16, height = 12 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 12">
            <path
                fill="currentColor"
                d="M.281 5.281a1.06 1.06 0 0 0 0 1.438l5 5a1.06 1.06 0 0 0 1.438 0 1.06 1.06 0 0 0 0-1.438L3.406 7H15c.563 0 1-.437 1-1s-.437-1-1-1H3.406L6.72 1.719a1.06 1.06 0 0 0 0-1.438 1.06 1.06 0 0 0-1.438 0z"
            />
        </svg>
    );
};

export default React.memo(ArrowLeft);
